function changeToSentecesText(inputText) {
  const words = inputText.split(' ');

  const formattedWords = words.map(word => {
    const firstLetter = word.charAt(0).toUpperCase();
    const restOfWord = word.slice(1).toLowerCase();

    return firstLetter + restOfWord;
  });

  const formattedText = formattedWords.join(' ');

  return formattedText;
}

export default changeToSentecesText;
